import React from 'react';
import PropTypes from 'prop-types';
import { Box } from '../Box';
import { Relative } from '../Relative';
import { Flex } from '../Flex';
const propTypes = {
    children: PropTypes.node,
    arrowPosition: PropTypes.oneOf(['top', 'bottom', 'side', 'hide', undefined]),
};
const SlideBoxWrapper = ({ children, arrowPosition }) => arrowPosition === 'side' ? (React.createElement(Relative, null,
    React.createElement(Flex, { alignItems: 'center' }, children))) : (React.createElement(Box, null, children));
export { SlideBoxWrapper };
//# sourceMappingURL=SlideBoxWrapper.js.map